import { createContext, FunctionComponent } from 'preact';
import { useContext, useMemo } from 'preact/hooks';

import type { PlayerConfigPaywall } from '../../../types/global';
import { UtmParameters } from '../../../utils/getUtmParams';

interface PaywallContextProps {
  login: () => void;
  utmParameters?: UtmParameters;
  getSubscriptionUrl?: PlayerConfigPaywall['getSubscriptionUrl'];
}

const PaywallContext = createContext<PaywallContextProps>(undefined!);

export interface PaywallProviderProps {
  login: () => void;
  utmParameters?: UtmParameters;
  getSubscriptionUrl?: PlayerConfigPaywall['getSubscriptionUrl'];
}

export const PaywallProvider: FunctionComponent<PaywallProviderProps> = ({
  login,
  utmParameters,
  getSubscriptionUrl,
  children,
}) => {
  const state = useMemo(() => {
    return {
      login,
      utmParameters,
      getSubscriptionUrl,
    };
  }, [login, utmParameters, getSubscriptionUrl]);

  return (
    <PaywallContext.Provider value={state}>{children}</PaywallContext.Provider>
  );
};

export const usePaywall = () => {
  const paywall = useContext(PaywallContext);

  if (process.env.NODE_ENV !== 'production' && !paywall) {
    console.warn(
      'Paywall context is undefined, please verify you are calling usePaywall() as child of a <PaywallProvider> component.'
    );
  }

  return paywall;
};
